// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuItem_wrapper__mNdK8","iconContainer":"MenuItem_iconContainer__nvcLr"};